import script from "./ynSelect.vue?vue&type=script&lang=js"
export * from "./ynSelect.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__